// src/pages/ApplyReissuePassport.jsx
import React from "react";
import styled from "styled-components";
import ReissuePassport from "../component/ReissuePassport";
const MainCon = styled.div`
  text-align: center;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;

  margin-top: 20px;
  color: #e6e6e6;
`;
const ApplyReissuePassport = () => {
  return (
    <MainCon>
      <h1>Apply for Re-issue Passport</h1>
      <p>Apply for re-issuing your expired or damaged passport here.</p>
      {/* Form or details for application can go here */}
      <ReissuePassport />
    </MainCon>
  );
};

export default ApplyReissuePassport;
